export default {
  small: '0px 0px 4px rgba(171, 190, 209, 0.4)',
  medium: '0px 0px 8px rgba(171, 190, 209, 0.4)',
  large: '0px 0px 12px rgba(171, 190, 209, 0.4)',
};
